export const createReportViewer = (isAdmin) => {
  const viewer = new window.Stimulsoft.Viewer.StiViewer(null, "StiViewer", false);

  if (!isAdmin) {
    viewer.options.toolbar.showSaveButton = false;
    viewer.options.toolbar.showPrintButton = false;
    viewer.options.toolbar.showOpenButton = false;
    viewer.options.toolbar.showSendEmailButton = false;

    Object.keys(viewer.options.exports).forEach((key) => {
      if (key.indexOf("showExport") === 0) {
        viewer.options.exports[key] = false;
      }
    });
  }

  return viewer;
};
